import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { adminService } from '../services/adminService';
import AdminLogin from './AdminLogin';
import AdminPanel from './AdminPanel';

const ProtectedAdminRoute: React.FC = () => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [showLoginModal, setShowLoginModal] = useState(false);

  useEffect(() => {
    checkAdminStatus();
  }, []);

  const checkAdminStatus = async () => {
    setIsLoading(true);
    try {
      // 首先检查本地登录状态
      const localStatus = adminService.isLoggedIn();
      
      if (localStatus) {
        // 如果本地有登录状态，验证服务端
        const serverStatus = await adminService.checkAdminStatus();
        setIsAdmin(serverStatus);
        if (!serverStatus) {
          setShowLoginModal(true);
        }
      } else {
        setIsAdmin(false);
        setShowLoginModal(true);
      }
    } catch (error) {
      console.error('Admin status check failed:', error);
      setIsAdmin(false);
      setShowLoginModal(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleLoginSuccess = () => {
    setIsAdmin(true);
    setShowLoginModal(false);
  };

  const handleLogout = async () => {
    try {
      await adminService.logout();
      setIsAdmin(false);
      setShowLoginModal(true);
    } catch (error) {
      console.error('Logout failed:', error);
      // 即使退出登录失败，也清除本地状态
    setIsAdmin(false);
    setShowLoginModal(true);
    }
  };

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">正在验证管理员权限...</p>
        </div>
      </div>
    );
  }

  if (!isAdmin) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="bg-white p-8 rounded-lg shadow-md max-w-md w-full">
          <div className="text-center mb-6">
            <h1 className="text-2xl font-bold text-gray-900">管理后台</h1>
            <p className="text-gray-600 mt-2">请登录以访问管理功能</p>
          </div>
          
          <AdminLogin
            isOpen={showLoginModal}
            onClose={() => setShowLoginModal(false)}
            onLoginSuccess={handleLoginSuccess}
          />
        </div>
      </div>
    );
  }

  return (
    <div>
      {/* Admin 头部导航 */}
      <div className="bg-white shadow-sm border-b">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <div className="flex items-center space-x-4">
              <h1 className="text-xl font-semibold text-gray-900">管理后台</h1>
              <span className="text-sm text-gray-500">
                已登录为管理员: {adminService.getCurrentUser()?.email}
              </span>
            </div>
            <div className="flex items-center space-x-4">
              <button
                onClick={() => window.open('/', '_blank')}
                className="inline-flex items-center px-3 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
              >
                查看网站
              </button>
              <button
                onClick={handleLogout}
                className="inline-flex items-center px-3 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700"
              >
                退出登录
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Admin 面板内容 */}
      <AdminPanel />
    </div>
  );
};

export default ProtectedAdminRoute; 